import { CloseCircleFilled, PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Button,
  Card,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Form,
  Input,
  Layout,
  Popconfirm,
  Row,
  Select,
  Space,
  Spin,
  Typography,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import CustomButton from "../../../../components/custom/CustomButton";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import { taxGroupApi, taxGroupLabel, taxGroupStatic } from "./taxGroup.config";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const { Text, Title } = Typography;

const EditTaxGroup = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  const navigate = useNavigate();
  const [useForm] = Form.useForm();

  const [taxGroupDetail, setTaxGroupDetail] = useState([]);
  const [taxComponentData, setTaxComponentData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDetailById();
  }, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${taxGroupApi.taxGroup}/${state.id}?template=true`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        let tempTaxComponentData = [];

        // SHOW THE SAVED DATA
        useForm.setFieldsValue({
          name: objDetail.name,
        });

        objDetail?.taxComponents?.forEach((element) => {
          tempTaxComponentData.push({
            value: element.id,
            label: element.name,
          });
        });

        setTaxComponentData(tempTaxComponentData);
        setTaxGroupDetail(objDetail?.taxAssociations);
        setIsLoading(false);
      }
    });
  };

  const endDateRef = taxGroupDetail.find((item) => item.endDate);

  function onCancel() {
    navigate("/prd1301", { replace: false });
  }

  const onSubmit = (formValues) => {
    // return;
    let taxComponentsPayload = [];
    let initialTaxComponentDetail = [];

    taxGroupDetail.forEach((item) => {
      let dates = `endDate${item.id}`;
      let endDates = !item.endDate
        ? BOM.DateTime(formValues[dates], "only-date")
        : BOM.DateTime(item?.endDate, "only-date");
      initialTaxComponentDetail.push({
        id: item.id,
        taxComponentId: item.taxComponent.id,
        endDate: endDates,
      });
    });

    formValues.initialTaxComponentDetail = initialTaxComponentDetail.filter((item) => item.endDate);

    if (formValues.taxComponents) {
      formValues.taxComponents.forEach((element) => {
        taxComponentsPayload.push({
          // id: element.taxComponentId,
          taxComponentId: element.taxComponentId,
          startDate: BOM.DateTime(element.startDate, "only-date"),
        });
      });
    }

    formValues.taxComponents = taxComponentsPayload;
    const payLoadValues = {
      name: formValues.name,
      taxComponents: [...formValues.initialTaxComponentDetail, ...formValues.taxComponents],
    };

    const url = `${taxGroupApi.taxGroup}/${state.id}`;

    const body = {
      ...payLoadValues,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: "PUT",
      session,
    };

    // return;
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, taxGroupLabel.editTaxGroupMsg);
          navigate("/prd1301", { state: { id: res.resourceId } });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/prd1301", { state: { id: res.resourceId } });
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={taxGroupLabel.editTaxGroup}
        pageItems={taxGroupStatic.editTaxGroupItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            // initialValues={{
            //   taxComponents: [{}],
            // }}
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {taxGroupLabel.taxGroupSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />

            <Row>
              <Col span={8} style={{ padding: "0px 0px" }}>
                <Form.Item
                  label={taxGroupLabel.name}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(taxGroupLabel.name),
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Divider orientation="left" orientationMargin="0">
                  {taxGroupLabel.taxComponents}
                </Divider>
                <Title
                  level={5}
                  style={{ paddingTop: 10, paddingBottom: 10, marginTop: 10 }}
                ></Title>
                {taxGroupDetail.map((item, index) => (
                  <Row key={index}>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={<Text strong>{taxGroupLabel.taxComponent}</Text>}>
                        <Input disabled value={item.taxComponent.name} />
                      </Form.Item>
                    </Col>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      <Form.Item label={<Text strong>{taxGroupLabel.startDate}</Text>}>
                        <Input disabled value={BOM.FormatArrayDate(item.startDate)} />
                      </Form.Item>
                    </Col>
                    <Col span={8} style={{ padding: "0px 8px" }}>
                      {/* {!("endDate" in item) ? ( */}
                      {!item.endDate ? (
                        <Form.Item
                          name={`endDate${item.id}`}
                          label={<Text strong>{taxGroupLabel.endDate}</Text>}
                        >
                          <DatePicker
                            style={{ width: "30vh" }}
                            placeholder={BOM.handlePlaceholderMsg(taxGroupLabel.endDate)}
                          />
                        </Form.Item>
                      ) : (
                        <Form.Item label={<Text strong>{taxGroupLabel.endDate}</Text>}>
                          <Input disabled value={BOM.FormatArrayDate(item.endDate)} />
                        </Form.Item>
                      )}
                    </Col>
                  </Row>
                ))}
                <Form.List name="taxComponents">
                  {(fields, { add, remove }) => (
                    <div
                      style={{
                        display: "flex",
                        rowGap: 16,
                        flexDirection: "column",
                      }}
                    >
                      {fields.map((field) => (
                        <Space
                          key={field.key}
                          title={`Item ${field.name + 1}`}
                          size="small"
                          style={{
                            display: "flex",
                            marginBottom: 8,
                          }}
                          align="baseline"
                        >
                          <Form.Item
                            name={[field.name, "taxComponentId"]}
                            rules={[
                              {
                                required: true,
                                message: BOM.CheckReqFld(taxGroupLabel.taxComponent),
                              },
                            ]}
                          >
                            <Select
                              placeholder={BOM.handlePlaceholderMsg(taxGroupLabel.taxComponent)}
                              style={{ width: "30vh" }}
                              options={taxComponentData}
                              showSearch
                            />
                          </Form.Item>
                          <Form.Item
                            name={[field.name, "startDate"]}
                            rules={[
                              {
                                required: true,
                                message: BOM.CheckReqFld(taxGroupLabel.startDate),
                              },
                            ]}
                          >
                            <DatePicker
                              style={{ width: "30vh" }}
                              placeholder={BOM.handlePlaceholderMsg(taxGroupLabel.startDate)}
                            />
                          </Form.Item>
                          {/* {taxGroupDetail != "-" && (
                            <Form.Item
                              name={[field.name, "endDate"]}
                              rules={[
                                {
                                  required: true,
                                  message: BOM.CheckReqFld(
                                    taxGroupLabel.startDate
                                  ),
                                },
                              ]}
                            >
                              <DatePicker
                                style={{ width: "30vh" }}
                                placeholder={BOM.handlePlaceholderMsg(
                                  taxGroupLabel.startDate
                                )}
                              />
                            </Form.Item>
                          )} */}
                          <Popconfirm
                            title="Sure to delete?"
                            onConfirm={() => remove(field.name)}
                            okText="OK"
                            cancelText="Cancel"
                            okButtonProps={{
                              style: {
                                backgroundColor: "#15CCAE",
                                color: "white",
                                height: "15%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                              },
                            }}
                            cancelButtonProps={{
                              style: {
                                height: "15%",
                                backgroundColor: "white",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                              },
                            }}
                          >
                            <CloseCircleFilled
                              height={2}
                              width={2}
                              style={{
                                color: "#92428B",
                                fontSize: "25px",
                                fontWeight: "bolder",
                                marginLeft: "20px",
                              }}
                            />
                          </Popconfirm>
                        </Space>
                      ))}

                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        style={{
                          backgroundColor: "#15CCAE",
                          color: "white",
                          width: "15vh",
                          marginBottom: 20,
                        }}
                        onClick={() => add()}
                      >
                        Add
                      </Button>
                    </div>
                  )}
                </Form.List>
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(EditTaxGroup);
